import { ButtonAdd } from "@neonumy/ant-design";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdEdit } from "react-icons/md";
import { Col, Form, Input, InputNumber, Modal, notification, Row } from "antd";
import { useForm } from "antd/es/form/Form";

const { TextArea } = Input;
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { getFormError } from "utils/getFormError";
import useNotification from "utils/hooks/useNotification";
import useCoreStore from "views/hooks/useCoreStore";
import useGeneralApi from "views/Settings/General/hooks/useGeneralApi";

interface CreateUpdateFormPropsType {
  id?: ID;
  refetch: any;
}

export default function CreateUpdateForm({ id, refetch }: CreateUpdateFormPropsType) {
  const { t } = useTranslation();
  const [form] = useForm();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const companySelected = useCoreStore(state => state.companySelected);

  const { createUpdatePaymentDeadline, getPaymentDeadline } = useGeneralApi(id, form);
  const { notificationError } = useNotification();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  useEffect(() => {
    if (isModalOpen && id) {
      getPaymentDeadline({ variables: { id: id } });
    }
  }, [isModalOpen, id]);

  const onFinish = async (values: Record<string, any>) => {
    const updateId = id ? { id } : {};
    let errors: any = [];

    const response = await createUpdatePaymentDeadline({
      variables: {
        input: {
          company: companySelected?.id,
          ...values,
          ...updateId,
        },
      } as unknown as NonNullable<Parameters<typeof createUpdatePaymentDeadline>[0]>["variables"],
    });

    errors = id
      ? response?.data?.updateCompanyPaymentDeadline?.errors
      : response?.data?.createCompanyPaymentDeadline?.errors;

    if (errors && errors.length > 0) {
      const fieldsData = getFormError(errors, values);
      notificationError(errors);
      form.setFields(fieldsData);
    } else {
      setIsModalOpen(false);
      refetch();
      form.resetFields();

      notification.success({
        message: t("Payment date limit"),
        description: t("Saved Successfully"),
        placement: "bottomLeft",
      });
    }
  };

  return (
    <>
      {id ? (
        <TooltipButton placement="top" handleOnClick={showModal} icon={<MdEdit />} />
      ) : (
        <Row justify="end">
          <ButtonAdd type="primary" onClick={showModal}>
            {t("Add")}
          </ButtonAdd>
        </Row>
      )}
      <Modal
        title={id ? t("Update payment date") : t("Create payment date")}
        open={isModalOpen}
        onOk={handleOk}
        okText={t("Save")}
        okButtonProps={{
          icon: (
            <span className="anticon">
              <FaSave />
            </span>
          ),
        }}
        width={768}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={8}>
            <Col xs={24} sm={24}>
              <Form.Item
                name="name"
                label={t("Name")}
                rules={[{ required: true, message: t("This field is required") }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item name="description" label={t("Description")}>
                <TextArea rows={3} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="beginningDay"
                label={t("Beginning day")}
                initialValue={0}
                rules={[{ required: true, message: t("This field is required") }]}
              >
                <InputNumber max={30} min={0} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="numberOfDays"
                label={t("Number of days")}
                initialValue={0}
                rules={[{ required: true, message: t("This field is required") }]}
              >
                <InputNumber min={0} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="payDay"
                label={t("Pay day")}
                initialValue={0}
                rules={[{ required: true, message: t("This field is required") }]}
              >
                <InputNumber max={30} min={0} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
